"use strict";

document.addEventListener("DOMContentLoaded", function () {
  var accordions = document.querySelectorAll(".accordion .q");

  accordions.forEach(function (accordion) {
    accordion.addEventListener("click", function () {
      var box = this.closest(".box");
      
      if (box.classList.contains("opened")) {
        box.classList.remove("opened");
        box.querySelector(".a").style.maxHeight = "0";
        box.querySelector(".minus").style.display = "none";
        box.querySelector(".plus").style.display = "inline";
      } else {
        document.querySelectorAll(".accordion .box.opened").forEach(function (openedBox) {
          openedBox.classList.remove("opened");
          openedBox.querySelector(".a").style.maxHeight = "0";
          openedBox.querySelector(".minus").style.display = "none";
          openedBox.querySelector(".plus").style.display = "inline";
        });

        box.classList.add("opened");
        var aElement = box.querySelector(".a");
        aElement.style.maxHeight = aElement.querySelector("p").offsetHeight + "px";
        box.querySelector(".minus").style.display = "inline";
        box.querySelector(".plus").style.display = "none";
      }
    });
  });
});

document.querySelectorAll('.accordion-header').forEach(function(header) {
  header.addEventListener('click', function() {
    // const contents = this.nextElementSibling;
    const contents = document.querySelector('.accordion-contents');
    this.classList.toggle('active');

    const toggleText = this.querySelector('.toggle-text');

    if (contents.style.maxHeight) {
      contents.style.maxHeight = null;
      if (toggleText) toggleText.textContent = "詳しくはこちら";
    } else {
      contents.style.maxHeight = 10000 + "px";
      if (toggleText) toggleText.textContent = "詳細を閉じる";
    } 
  });
});